import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import Design from './Design';


ReactDOM.render(
  <>
<App/>   
    </> ,
  document.getElementById('root')
);

